import { Component } from '@angular/core';

/**
 * Wrapper of every page of the module (font, background, bottom spacing). There is no footer of its own: the
 * route hangs from the landing shell, whose Brands by Rappi footer is the only one on the page.
 */
@Component({
  selector: 'app-learning-hub-layout',
  template: '<div class="lh-layout"><router-outlet></router-outlet></div>',
  // Default change detection: the routed pages render inside this view (an OnPush wrapper would freeze them).
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {}
